<template>
  <div>
    <div class="page-header-wrapper">
      <PageHeader id="Basic" title="Basic" />
    </div>
    <div
      class="basic-info table-wrapper"
      v-loading="infoLoading"
      element-loading-text="Loading..."
    >
      <el-row>
        <el-col :span="12">
          <el-col :span="6">
            <div class="basic-div">
              <strong>Name</strong>
              <span
                :title="info.SEName"
                v-text="info.SEName"
                class="basic-value"
              ></span>
            </div>
          </el-col>
          <el-col :span="18">
            <div class="basic-div">
              <strong>Hospital / Institution</strong>
              <span
                :title="info.Hospital"
                v-text="info.Hospital"
                class="basic-value"
              ></span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="basic-div">
              <strong>City</strong>
              <span
                :title="info.City"
                v-text="info.City"
                class="basic-value"
              ></span>
            </div>
          </el-col>
          <el-col :span="18">
            <div class="basic-div">
              <strong>Department</strong>
              <span
                :title="info.Department"
                v-text="info.Department"
                class="basic-value"
              ></span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="basic-div">
              <strong>Province</strong>
              <span
                :title="info.Province"
                v-text="info.Province"
                class="basic-value"
              ></span>
            </div>
          </el-col>
          <el-col :span="18">
            <div class="basic-div">
              <strong>Phone</strong>
              <span
                :title="info.Phone"
                v-text="info.Phone"
                class="basic-value"
              ></span>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="basic-div">
              <strong>Others</strong>
            </div>
          </el-col>
          <el-col :span="24">
            <div
              class="basic-div"
              style="display: flex; align-items: center; margin-top: 10px"
            >
              <el-input
                v-model="info.Others"
                placeholder="Please input"
                :maxlength="200"
                style="width: 400px"
              ></el-input>
              <el-button
                size="mini"
                type="danger"
                plain
                @click="saveOthers"
                style="margin-left: 20px"
                >Save</el-button
              >
            </div>
          </el-col>
        </el-col>
        <el-col :span="12">
          <el-col :span="24">
            <div class="basic-div" style="display: flex; align-items: center">
              <strong>Preference and Communication</strong>
              <div
                style="
                  padding-left: 10px;
                  color: #409eff;
                  display: flex;
                  align-items: center;
                  cursor: pointer;
                "
                @click="doEdit"
              >
                <i class="el-icon-edit-outline"></i>Edit
              </div>
            </div>
          </el-col>
          <el-col :span="24">
            <el-col :span="16">
              <div class="list-title">-Disease State Presentation</div>
            </el-col>
            <el-col :span="8">
              <div class="list-value">{{ info.DiseaseState }}</div>
            </el-col>
            <el-col :span="16">
              <div class="list-title">-NILEX Disease State Presentation</div>
            </el-col>
            <el-col :span="8">
              <div class="list-value">{{ info.NilexDisease }}</div>
            </el-col>
            <el-col :span="16">
              <div class="list-title">-Product Overview Presentation</div>
            </el-col>
            <el-col :span="8">
              <div class="list-value">{{ info.ProductOverview }}</div>
            </el-col>
            <el-col :span="16">
              <div class="list-title">-Medical Education Inform</div>
            </el-col>
            <el-col :span="8">
              <div class="list-value">{{ info.MedicalEducation }}</div>
            </el-col>
            <el-col :span="16">
              <div class="list-title">
                -Inform Activity (Label/Guideline Inform)
              </div>
            </el-col>
            <el-col :span="8">
              <div class="list-value">{{ info.InformActivity }}</div>
            </el-col>
            <el-col :span="16">
              <div class="list-title">-Safety Data Dissemination</div>
            </el-col>
            <el-col :span="8">
              <div class="list-value">{{ info.SafetyData }}</div>
            </el-col>
          </el-col>
        </el-col>
      </el-row>
    </div>
    <div class="page-header-wrapper" style="margin-top: 20px">
      <PageHeader :line="false">
        <template slot="title">
          <div
            style="display: flex; align-items: center"
            @click="showAllCollapse"
          >
            <h1 style="color: #000; font-size: 16px; white-space: nowrap">
              SR Menu - Therapeutic Area
            </h1>
            <div class="arrow-class" v-if="!showAll">
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="arrow-class-active" v-if="showAll">
              <i class="el-icon-arrow-down"></i>
            </div>
          </div>
        </template>
        <div>
          <el-button
            size="mini"
            type="danger"
            plain
            @click="goEdit"
            style="margin-right: 30px"
          >
            Edit
          </el-button>
          <el-select
            v-model="questionTopic"
            ref="questionTopic"
            placeholder="Please Choose"
            :clearable="false"
            filterable
            style="width: 200px"
            @change="handleChangeTopic"
          >
            <el-option
              v-for="item in taList"
              :key="item.questionnaireId"
              :label="item.title"
              :value="item.questionnaireId"
            />
          </el-select>
          <el-button
            size="mini"
            type="primary"
            @click="saveQuestionnaire"
            :loading="editQuestionLoading"
            :disabled="!editMode"
            style="margin-left: 30px"
          >
            Save
          </el-button>
        </div>
      </PageHeader>
      <div class="table-wrapper el-collapse-wrapper">
        <el-collapse v-model="collapse" @change="changeCollapse">
          <div v-for="item in questionForm.questions" :key="item.questionId">
            <el-collapse-item :name="item.title">
              <template slot="title">
                <PageHeader :id="item.questionId" :title="item.title" />
              </template>
              <div
                style="
                  width: 100%;
                  height: 36px;
                  display: flex;
                  align-items: center;
                  padding: 0 10px 0 0;
                "
                v-if="editMode"
              >
                <el-checkbox
                  v-model="item.checkAll"
                  @change="handleCheckAllChange($event, item)"
                  >Select All</el-checkbox
                >
              </div>
              <el-row v-if="editMode">
                <el-col
                  :span="6"
                  v-for="obj in item.options"
                  :key="obj.optionId"
                >
                  <div
                    style="
                      width: 100%;
                      height: 36px;
                      display: flex;
                      align-items: center;
                    "
                  >
                    <el-checkbox
                      v-model="obj.checked"
                      :label="obj.optionValue"
                      @change="handleItemCheckChange($event, item)"
                    >
                      {{ obj.optionValue }}
                    </el-checkbox>
                  </div>
                </el-col>
              </el-row>
              <el-row v-if="!editMode">
                <el-col
                  :span="6"
                  v-for="obj in item.options.filter((v) => v.checked)"
                  :key="obj.optionId"
                >
                  <div
                    style="
                      width: 100%;
                      height: 36px;
                      display: flex;
                      align-items: center;
                      color: #2c3e50;
                    "
                  >
                    <i class="dotClass" style="background-color: #2c3e50"></i>
                    <div>
                      {{ obj.optionValue }}
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-collapse-item>
          </div>
        </el-collapse>
      </div>
    </div>

    <EditSRMenuDialog
      :visible.sync="editSRDialogVisible"
      :data.sync="rowData"
      @success="onSuccess"
    />
  </div>
</template>

<script>
import EditSRMenuDialog from "./edit-sr-menu-dialog.vue";
import { RoleCode, HcpType } from "../../../utils/role-constant";
export default {
  name: "My-SR-Menu",
  components: {
    EditSRMenuDialog,
  },
  data() {
    return {
      info: {
        Active: 0,
        City: "",
        Department: "",
        Focus: "",
        Hospital: "",
        SEID: "",
        SEName: "",
        SENo: "",
      },
      focusCache: "",
      focus: "",
      newPushDialogVisible: false,
      qrcodeDialogVisible: false,
      rowData: null,
      infoLoading: false,
      collapse: [],
      activeCollapse: "",
      isAdmin: false,
      typeList: [],
      isVCE: false,
      editType: false,
      typeOfCustomer: "",
      taList: [],
      selectedQuestion: undefined,
      questionTopic: undefined,
      basicQuestionForm: {},
      questionForm: {},
      editSRDialogVisible: false,
      editQuestionLoading: false,
      editMode: false,
      showAll: true,
    };
  },
  computed: {
    path() {
      return this.$route.path;
    },
    seId() {
      return this.$route.params.seId;
    },
    hash() {
      return this.$route.hash ? this.$route.hash.substring(1) : "";
    },
    isNotBasic() {
      return this.hash !== "Basic";
    },
    role() {
      return this.$store.state.role;
    },
  },
  watch: {
    $route(to, from) {
      console.log(to, from)
      if (
        (to.name === "My-SE/CE-View" || to.name === "My-SR-View") &&
        this.info.SEID === this.seId
      ) {
        this.$nextTick(() => {
          this.handleCollapseChange();
          if (this.activeCollapse !== this.hash) {
            this.qrcodeDialogVisible = false;
            this.newPushDialogVisible = false;
            if (this.$refs.pushedContent) {
              this.$refs.pushedContent.closeDialog();
            }
            this.scrollTo();
          }
          if (this.isNotBasic) {
            this.activeCollapse = this.hash || this.activeCollapse;
          }
        });
      }
      if (to.name === 'sr-menu' && to.path !== from.path) {
        this.editMode = false;
        this.getQuestionForm();
      }
    },
  },
  created() {
    this.bus.$on("refresh", ({ name }) => {
      console.log(name)
      if (
        /^My-((SE\/CE)|Customer)-View$/.test(name) &&
        (this.info.SEID === "" || this.info.SEID === this.seId)
      ) {
        this.refresh();
      }
      if (
        name === "My-Hcp-View" &&
        (this.info.SEID === "" || this.info.SEID === this.seId)
      ) {
        this.refresh();
      }
      if (name === "My-HCP-View" || name === "My-vCE-View") {
        this.refresh();
      }
      if (name === "My-SR-Menu") {
        console.log(1);
        this.refresh();
      }
    });
    this.getInfo();
    this.getTaList();

    if (this.hash !== "" && this.isNotBasic) {
      this.collapse = [this.hash];
      this.activeCollapse = this.hash;
    }
    if (this.role === RoleCode.Admin) {
      this.isAdmin = true;
    }
  },
  methods: {
    getTypeList() {
      this.axios.get("/se/typeList").then(({ code, data }) => {
        if (code === 200) {
          this.typeList = data;
          //Supervisor，虽然是se+Customer，但是下拉里没有Customer，所以只显示se，如果切换成ce，提交的时候需要添加Customer
          //没有判断Supervisor来做判断为了防止其他角色也有同样操作，只要下拉没有即可
          const typeIdsInList = new Set(
            this.typeList.map((item) => item.TypeID)
          );
          this.typeOfCustomer = this.info.Types.filter(
            (id) => !typeIdsInList.has(id)
          );
          this.info.Types = this.info.Types.filter(
            (id) => !this.typeOfCustomer.includes(id)
          );

          this.isVCE = this.info.Types.includes(
            this.typeList.find((item) => item.TypeName == HcpType.vCE)?.TypeID
          );
          this.editType = true;

          if (this.info.Types.length == 1) {
            if (
              this.info.Types.includes(
                this.typeList.find((item) => item.TypeName == HcpType.vCE)
                  ?.TypeID
              ) ||
              this.info.Types.includes(
                this.typeList.find((item) => item.TypeName == HcpType.Customer)
                  ?.TypeID
              )
            ) {
              this.editType = false;
            }
          }
          if (this.editType) {
            this.typeList = this.typeList.filter(
              (item) => item.TypeName !== HcpType.vCE
            );
          }
          this.typeList = this.typeList.map((item) => {
            return {
              ...item,
              disabled: false,
            };
          });
        }
      });
    },
    scrollTo() {
      let hash = this.hash === "" ? "Basic" : this.hash;
      const appScrollbar = document.querySelector(".app>.el-scrollbar__wrap");
      const target = document.querySelector(`#${hash}`);
      if (target) {
        appScrollbar.scrollTop = target.offsetTop - 19;
      }
    },
    handleCollapseChange() {
      if (this.hash !== "" && !this.isNotBasic) {
        return;
      }
      const isExist = this.collapse.some((hash) => hash === this.hash);
      if (!isExist && this.hash) {
        this.collapse.push(this.hash);
      }
    },
    refresh() {
      this.getInfo();
      this.getTaList();
    },
    getInfo() {
      if (!this.seId) {
        return;
      }
      this.infoLoading = true;
      this.axios
        .get("/seDetail/viewInfo", {
          params: {
            seId: this.seId,
          },
        })
        .then(({ code, msg, data }) => {
          if (code === 200) {
            if (data) {
              this.info = data;
              this.focus = data.Focus;
              this.focusCache = data.Focus;
              this.bus.$emit("setTabTitle", {
                path: this.path,
                title: data.SEName,
              });
              this.getTypeList();
            } else {
              this.$alert("The se information is not found.", "Tips", {
                confirmButtonText: "Return SE/CE List Page",
                callback: () => {
                  const path = this.path;
                  this.$router.push("/se").then(() => {
                    this.bus.$emit("closeTab", {
                      path: path,
                    });
                  });
                },
              });
            }
          } else {
            this.$message.error(msg);
          }
          this.infoLoading = false;
        });
    },
    getTaList() {
      this.axios
        .get("/srMenu/ta", {
          params: {},
        })
        .then(({ code, msg, data }) => {
          if (code === 200) {
            if (data) {
              this.taList = data;
              if (this.taList && this.taList.length > 0) {
                this.selectedQuestion = this.taList[0].questionnaireId;
                this.questionTopic = this.taList[0].questionnaireId;
                this.getQuestionForm();
              }
            }
          } else {
            this.$message.error(msg);
          }
        });
    },
    getQuestionForm() {
      this.editQuestionLoading = true;
      this.axios
        .get("/srMenu/details", {
          params: {
            seId: this.seId,
            questionnaireId: this.selectedQuestion,
          },
        })
        .then(({ code, msg, data }) => {
          this.editQuestionLoading = false;
          if (code === 200) {
            if (data) {
              this.collapse = [];
              //处理原始数据，为了后续做比对
              this.basicQuestionForm = { ...data };
              this.basicQuestionForm.questions =
                this.basicQuestionForm.questions.map((item) => {
                  return {
                    ...item,
                    checkAll:
                      item.checkAll && item.checkAll !== undefined
                        ? item.checkAll
                        : false,
                  };
                });
              this.basicQuestionForm.questions.forEach((item) => {
                item.options = item.options.map((obj) => {
                  return {
                    ...obj,
                    checked:
                      obj.checked && obj.checked !== undefined
                        ? obj.checked
                        : false,
                  };
                });
              });
              //处理用户操作数据，为了后续做比对
              this.questionForm = { ...data };
              this.questionForm.questions = this.questionForm.questions.map(
                (item) => {
                  return {
                    ...item,
                    checkAll:
                      item.checkAll && item.checkAll !== undefined
                        ? item.checkAll
                        : false,
                  };
                }
              );
              this.questionForm.questions.forEach((item) => {
                item.options = item.options.map((obj) => {
                  return {
                    ...obj,
                    checked:
                      obj.checked && obj.checked !== undefined
                        ? obj.checked
                        : false,
                  };
                });
                //全部展开问卷面板
                this.collapse.push(item.title);
                this.showAll = true;
              });
            }
          } else {
            this.$message.error(msg);
          }
        });
    },
    doEdit() {
      this.rowData = this.info;
      this.editSRDialogVisible = true;
    },
    goEdit() {
      this.editMode = true;
    },
    showAllCollapse() {
      if (this.showAll) {
        this.collapse = [];
      } else {
        this.questionForm.questions.forEach((item) => {
          //全部展开问卷面板
          this.collapse.push(item.title);
        });
      }
      this.showAll = !this.showAll;
    },
    handleChangeTopic(val) {
      if (val) {
        if (!this.deepObjEqual(this.basicQuestionForm, this.questionForm)) {
          this.$confirm(
            "Changes not saved, do you want to save before change select?",
            "Attention",
            {
              confirmButtonText: "Yes",
              cancelButtonText: "No",
            }
          )
            .then(() => {
              let param = {
                seId: this.seId,
                questionnaireId: this.selectedQuestion,
                answer: this.questionForm,
              };
              this.axios
                .post("/srMenu/submit", {
                  ...param,
                })
                .then(({ code, msg }) => {
                  this.$refs.questionTopic.blur();
                  if (code === 200) {
                    this.selectedQuestion = val;
                    this.getQuestionForm();
                    this.editMode = false;
                    this.$message.success("Save successfully");
                  } else {
                    this.$message.error(msg);
                  }
                });
            })
            .catch(() => {
              this.$refs.questionTopic.blur();
              this.selectedQuestion = val;
              this.getQuestionForm();
            });
        } else {
          this.selectedQuestion = val;
          this.getQuestionForm();
        }
      }
    },
    changeCollapse(val) {
      console.log(val);
    },
    handleCheckAllChange(val, obj) {
      //“全选”变化对选项的影响
      if (val) {
        obj.options.forEach((item) => {
          this.$set(item, "checked", true);
        });
      } else {
        obj.options.forEach((item) => {
          this.$set(item, "checked", false);
        });
      }
      this.$store.state.editFlag = true;
      let param = {
        seId: this.seId,
        questionnaireId: this.selectedQuestion,
        answer: this.questionForm,
      };
      this.$store.state.editForm = { ...param };
    },
    handleItemCheckChange(val, obj) {
      //选项变化对“全选”的影响
      if (!val) {
        this.$set(obj, "checkAll", false);
      } else {
        let flag = 0;
        obj.options.forEach((item) => {
          if (!item.checked) {
            flag++;
          }
        });
        if (flag > 0) {
          this.$set(obj, "checkAll", false);
        } else {
          this.$set(obj, "checkAll", true);
        }
      }
      this.$store.state.editFlag = true;
      let param = {
        seId: this.seId,
        questionnaireId: this.selectedQuestion,
        answer: this.questionForm,
      };
      this.$store.state.editForm = { ...param };
    },
    deepObjEqual(obj1, obj2) {
      if (obj1 === obj2) return true;
      if (typeof obj1 !== "object" || typeof obj2 !== "object") return false;
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);
      if (keys1.length !== keys2.length) return false;
      for (let key of keys1) {
        if (!this.deepObjEqual(obj1[key], obj2[key])) return false;
      }
      return true;
    },
    saveOthers() {
      let param = {
        SEID: this.seId,
        Others: this.info.Others,
      };
      this.axios
        .post("/seDetail/updateOthers", {
          ...param,
        })
        .then(({ code, msg }) => {
          if (code === 200) {
            this.$message.success("Save successfully");
          } else {
            this.$message.error(msg);
          }
        });
    },
    saveQuestionnaire() {
      let param = {
        seId: this.seId,
        questionnaireId: this.selectedQuestion,
        answer: this.questionForm,
      };
      this.axios
        .post("/srMenu/submit", {
          ...param,
        })
        .then(({ code, msg }) => {
          if (code === 200) {
            this.getQuestionForm();
            this.$message.success("Save successfully");
            this.$store.state.editFlag = false;
            this.$store.state.editForm = {};
            this.editMode = false;
          } else {
            this.$message.error(msg);
          }
        });
    },
    onSuccess() {
      this.getInfo();
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.seId) next();
    else next("/se");
  },
};
</script>

<style lang="scss" scoped>
.basic-info {
  display: flex;

  & > div {
    min-width: 250px;
    height: 180px;
    //border: 1px solid #dcdfe6;
    border-radius: 4px;
  }

  .avatar-info {
    min-width: 300px;
    width: 300px;
    padding: 25px 15px 15px;
    background-color: #f9fafc;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: 15px;

    .avatar-name {
      display: flex;
      align-items: center;
    }

    .name-status {
      margin-left: 15px;

      h3 {
        margin-bottom: 5px;
      }

      .el-tag {
        height: 18px;
        line-height: 16px;
      }
    }

    .actions {
      display: flex;

      .el-button {
        width: 100%;
      }

      margin-top: 25px;
    }
  }

  .focus-area {
    flex: 1;
    padding: 5px 10px;
    margin-right: 15px;
    display: flex;
    flex-direction: column;

    h4 {
      line-height: 25px;
    }

    .el-textarea {
      flex: 1;

      ::v-deep textarea {
        min-height: 66px !important;
        max-height: 66px !important;
      }
    }

    .actions {
      margin-top: 5px;
      text-align: right;
    }
  }

  .profile-detail {
    min-width: 120px;
    width: 100%;
    max-width: 400px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;

    div {
      padding: 0 1.5%;
      height: 30px;
      line-height: 25px;
      display: flex;
      align-items: center;

      &:nth-child(2n) {
        background-color: #f9fafc;
      }

      strong {
        display: inline-block;
        width: 140px;
        border-right: 1px solid rgba(213, 43, 30, 0.5);
        margin-right: 15px;
      }

      p {
        flex: 1;
        width: 0;
        overflow: hidden;
        text-overflow: ellipsis;

        span {
          height: 30px;
          display: inline;
          white-space: nowrap;
        }
      }
    }
  }
}

.el-collapse-wrapper {
  padding: 0px 10px 15px 10px !important;
  //margin-top: 15px;

  .padding-lr {
    padding-top: 10px;
  }

  ::v-deep {
    .el-table {
      min-height: auto !important;
    }

    .el-collapse-item__header.is-active {
      border-top: 1px solid rgba(213, 43, 30, 0.3);
      background-color: rgba(213, 43, 30, 0.05);
    }

    .el-collapse-item__arrow.el-icon-arrow-right {
      &.is-active {
        background: #d52b1e;
        color: #fff;
      }

      padding: 1px;
      border-radius: 100%;
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
    }

    .el-collapse-item__content {
      padding: 10px 0 !important;
    }
  }

  .el-collapse-item:last-child {
    ::v-deep .el-collapse-item__wrap {
      border: none;
    }
  }
}

.edit-input {
  display: flex !important;
  align-items: center;
}

.type-select {
  ::v-deep .el-tag__close.el-icon-close {
    display: none !important;
  }

  ::v-deep .el-select__tags {
    height: 28x;
    margin-top: -4px;
  }
}

::v-deep .type-select {
  height: 35px;
  overflow: hidden;
}

.basic-div {
  width: 100%;
  height: 30px;
  line-height: 30px;

  .basic-value {
    padding-left: 10px;
  }
}

.list-title {
  font-size: 12px;
  height: 25px;
  line-height: 25px;
  color: #999999;
  font-weight: 700;
}

.list-value {
  font-size: 12px;
  color: #2c3e50;
  height: 25px;
  line-height: 25px;
}

::v-deep .el-checkbox__label {
  display: inline-block;
  word-wrap: break-word;
  white-space: normal;
}

::v-deep .el-checkbox {
  display: flex;
  align-items: center;
}

.dotClass {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: block;
  margin-right: 5px;
}

.arrow-class {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #999999;
  color: #999999;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  cursor: pointer;
}

.arrow-class-active {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #d52b1e;
  background: #d52b1e;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  cursor: pointer;
}
</style>
